export default {
  SET_EDIT_STATE_PAGE(state, payload) {
    state.editPageState.data = payload.data;
    state.editPageState.count = payload.count;
  },
  SET_ALL_SECTORS(state, sectors) {
    state.sectors = sectors;
  },
  SET_ALL_INDUSTRIES(state, industries) {
    state.industries = industries;
  },
  SET_ALL_CITIES(state, cities) {
    state.cities = cities;
  },
  SET_ALL_STUDY_FIELDS(state, studyFields) {
    state.studyFields = studyFields;
  },
  SET_ALL_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_ALL_JOB_FUNCTIONS(state, jobFunctions) {
    state.jobFunctions = jobFunctions;
  },

  SET_ALL_JOB_CATEGORIES(state, jobCategories) {
    state.jobCategories = jobCategories;
  },

  SET_ALL_CERTIFICATION_FIELDS(state, certificationFields) {
    state.certificationFields = certificationFields;
  },
  SET_ALL_SERVICES(state, services) {
    state.services = services
  },
  SET_ALL_DEPARTMENT(state, department) {
    state.departments = department;
  },
  SET_ALL_EMPLOYEE_RANGE(state, range) {
    state.allEmployeeRange = range;
  },
  SET_ALL_EMPLOYEE_RANGE_LIST(state, range) {
    state.allEmployeeRangeList = range;
  },

};
